
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ConnectSUI from './component/connectSUI';
//import Test2 from './component/test2';
function App() {
  return (
    
        <Router>
          <Routes>
            <Route path="/connect-sui" element={<ConnectSUI />} />
            {/* <Route path="/test" element={<Test2 />} /> */}
            <Route path="/" element={<Navigate to="/connect-sui" />} />
          </Routes>
        </Router>
  
  );
}

export default App;